const normalizeToArray = (value: string | string[] | undefined): string[] => {
  return Array.isArray(value) ? value : value ? [value] : [];
};

export {
  normalizeToArray
}
